/* eslint-disable no-console */
import {LoggerBase, ReportErrorsPrefix} from 'yougile-util'
import {Backend} from './backend'

export class BackendReportLogger implements LoggerBase {
  log<T extends unknown[]>(...args: T): void {
    console.log(...args)
  }
  warn<T extends unknown[]>(...args: T): void {
    console.warn(...args)
  }
  error<T extends unknown[]>(...args: T): void {
    if (args[0] === ReportErrorsPrefix) {
      Backend.report(...(args as Array<string | number | undefined>))
    } else {
      console.error(...args)
    }
  }
}
